(function(){
  function show(el){el.classList.add('is-visible');el.setAttribute('aria-hidden','false')}
  function hide(el){el.classList.remove('is-visible');el.setAttribute('aria-hidden','true')}
  async function addToCartAndCheckout(variantId, clear, btn){
    if(!variantId){alert('Please choose your size first.');return}
    var label=btn.textContent;btn.textContent='One moment…';btn.disabled=true;
    try{
      if(clear==='true'||clear===true){await fetch('/cart/clear.js',{method:'POST'})}
      var res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(variantId),quantity:1})});
      if(!res.ok){var err={};try{err=await res.json()}catch(_){}
        alert(err.description||'Something went wrong. Please try again.');btn.textContent=label;btn.disabled=false;return}
      window.location.href='/checkout'
    }catch(_){btn.textContent=label;btn.disabled=false;alert('Something went wrong. Please try again.')}
  }
  document.addEventListener('click',function(e){
    var sz=e.target.closest('.btf-size-btn');
    if(sz&&!sz.disabled){
      window.btfVariant=sz.getAttribute('data-variant-id');
      document.querySelectorAll('.btf-size-btn').forEach(function(b){
        var on=b.getAttribute('data-variant-id')===window.btfVariant;
        b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false')
      });
      return
    }
    var btn=e.target.closest('.btf-atc');
    if(btn){e.preventDefault();addToCartAndCheckout(window.btfVariant||btn.getAttribute('data-variant-id'),btn.getAttribute('data-clear-cart'),btn)}
  });
  function init(){
    var act=document.querySelector('.btf-size-btn.is-active');
    if(act){window.btfVariant=act.getAttribute('data-variant-id')}
    var pdp=document.getElementById('btf-pdp');var sticky=document.querySelector('.btf-sticky');
    if(pdp&&sticky){
      var pdpVisible=false;
      var update=function(){if(window.scrollY>650&&!pdpVisible){show(sticky)}else{hide(sticky)}};
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){pdpVisible=en[0].isIntersecting;update()},{threshold:0.12}).observe(pdp)
      }
      window.addEventListener('scroll',update,{passive:true});update()
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();